const routes = {
  LOGIN: '/login',
  LAYOUT: '/*',
  ERROR: '/error',
  SUBPAGE: '/subpage',
  LIST_TAGS: '/list-tags',
  CREATE_SOFT_TAG: '/create-soft-tag',
  BULK_IMPORTS_HISTORY: '/bulk-imports-history',
  EDIT_SOFT_TAG: '/edit-soft-tag',
  BACKFILL_SOFT_TAG: '/backfill-soft-tag',
};
export default routes;
